export default __webpack_public_path__ + "static/media/sample2_v2.6f68700d.png";